import { Observable } from 'rxjs/Observable';
import { logUserIn } from '../utils/api';
import { AccountApi } from '../parsers';
import {
  LOG_IN_REQUESTED,
  loginSucceeded,
  loginFailed,
  signup,
  signUpFailed,
} from '../redux/account';

import type { ActionObs, Store, Obs } from '../types';

export default function loginEpic(action$: ActionObs, store: Store): Obs {
  return action$
    .ofType(LOG_IN_REQUESTED)
    .switchMap(({ payload: { email, password, additionalSignUpInfo } }) => {
      if (email.length && password.length) {
        return logUserIn({
          account: { email_address: email, password },
          remember_me: true,
        })
          .map(response => {
            if (response.status === 'error') {
              // Why do we do this? Because the api returns a 200 even when
              // you are unauthorized. So you have to keep this, no matter
              // how much it pains you.
              let signUpInfo;
              if (additionalSignUpInfo) {
                const { allowMarketing, userAgent } = additionalSignUpInfo;
                signUpInfo = { email, password, allowMarketing, userAgent };
              }
              throw new LoginError(response.message, signUpInfo);
            } else if (response.duo_auth_required) {
              // If this is an admin logging into production and they need
              // duo auth, forward them to the duo url provided in the response
              const duoLink = `${response.session_path}`;
              throw new NeedsDuo(duoLink);
            } else {
              return response;
            }
          })
          .map(resp => AccountApi.parse(resp))
          .map(({ account }) => loginSucceeded(account, 'email'))
          .catch(err => {
            if (err.name === 'NeedsDuoError') {
              return (window.location.href = err.message);
            } else if (err.name === 'LoginError') {
              return err.signUpInfo
                ? Observable.of(signup(err.signUpInfo))
                : Observable.of(loginFailed({ message: err.message }));
            } else {
              return Observable.of(loginFailed({ message: err.message }));
            }
          });
      } else {
        const messageErrorType = email.length
          ? { message: 'Password is required.', errorType: 'password' }
          : { message: 'Email address is required.', errorType: 'email' };

        return additionalSignUpInfo
          ? Observable.of(signUpFailed(messageErrorType))
          : Observable.of(loginFailed(messageErrorType));
      }
    });
}

class NeedsDuo extends Error {
  constructor(message) {
    super(message);
    this.name = 'NeedsDuoError';
  }
}

class LoginError extends Error {
  signUpInfo: ?Object;

  constructor(message, signUpInfo) {
    super(message);
    this.name = 'LoginError';
    this.signUpInfo = signUpInfo;
  }
}
